import { createPopper } from '@popperjs/core';

document.addEventListener('alpine:init', () => {

	Alpine.store('userHoverProfile', {
		id: null,
		instance: null,
		visible: false,
		hideTimeout: null,
		el: null,
		trigger: null,

		/*
		 * Counts the requests made. There is only one card, so a slow reply for somebody
		 * hovered a moment ago must not be allowed to paint itself over whoever is being
		 * hovered now. Each request remembers the number it was given and drops its reply
		 * if another has been started since.
		 */
		request: 0,

		async show(trigger, id) {

			/*
			 * The trigger is shown on a delay, so by the time this runs the element it was
			 * anchored to may have been taken off the page — most obviously by clicking it,
			 * since that navigates. Positioning against a detached element puts the card in
			 * the top left corner of the screen.
			 */
			if (! trigger || ! trigger.isConnected) {
				return;
			}

			clearTimeout(this.hideTimeout);

			const request = ++this.request;

			this.id = id;
			this.trigger = trigger;
			this.el = document.getElementById("user-profile-hover");
			this.visible = true;
			this.el.style.display = "block";
			this.el.innerHTML = `
			<div class="p-4 flex flex-col items-center justify-center">
				<i class="fa-solid fa-spinner-third fa-spin text-primary text-7xl"></i>
			</div>
			`;

			if(!this.instance)
			{

				this.instance = createPopper(this.trigger, this.el, {
					placement: 'auto',
					modifiers: [
						{ name: "offset", options: { offset: [0, 8] }},
						{ name: "preventOverflow", options: { boundary: 'viewport', padding: 8 } },
						{ name: 'flip', options: { fallbackPlacements: ['top', 'right'] } },
					]
				});

			}
			else
			{
				this.instance.setOptions({
					placement: 'auto',
					modifiers: [{ name: 'offset', options: { offset: [0, 8] } }]
				})
				this.instance.state.elements.reference = trigger
				this.instance.update()
			}


			try {

				/*
				 * The id is taken from the argument rather than this.id, which another
				 * hover may already have moved on by the time this line runs.
				 */
				const response = await fetch(route('app.async.user.mini-profile', { id }));
				const html = await response.text();

				/* Somebody else is being hovered now, so this reply is stale. */
				if (request !== this.request) {
					return;
				}

				this.el.innerHTML = html;

				await Alpine.nextTick();

				this.instance.update()

			}
			catch(e) {

				if (request !== this.request) {
					return;
				}

				console.log(e);
				this.el.innerHTML = `
					<div class="p-4">
						<div class="alert alert-error flex items-center gap-2">
							<i class="fa-solid fa-triangle-exclamation fa-lg"></i>
							There was an issue loading this users profile. Please try again later.
						</div>
					</div>
				`;
			}

		},

		scheduleHide() {
			clearTimeout(this.hideTimeout);

			this.hideTimeout = setTimeout(() => {
				this.visible = false
				if (this.el) this.el.style.display = 'none'
			}, 200);

		},

		cancelHide() {
			clearTimeout(this.hideTimeout);
		},

		hide() {

			clearTimeout(this.hideTimeout);

			this.visible = false;

			if (this.el) {
				this.el.style.display = 'none';
			}
		},

		/*
		 * Put the card away and forget what it was anchored to.
		 *
		 * The card itself is inside @persist so it survives a wire:navigate, which is what
		 * lets it outlive the page it was opened from. The element it was positioned
		 * against does not survive, so the popper instance is thrown away too rather than
		 * left holding a reference to something no longer in the document.
		 */
		reset() {

			this.hide();

			/* Discards any reply still in flight for the page being left. */
			this.request++;

			this.id = null;
			this.trigger = null;

			if (this.el) {
				this.el.innerHTML = '';
			}

			if (this.instance) {
				this.instance.destroy();
				this.instance = null;
			}
		}

	});

	/*
	 * A hovered card must not be left behind when the page changes under it. Nothing else
	 * puts it away: the trigger is removed rather than moused away from, so it never fires
	 * mouseleave.
	 */
	document.addEventListener('livewire:navigating', () => Alpine.store('userHoverProfile').reset());

	Alpine.data('userHoverProfile', () => ({

		get visible() {
			return Alpine.store('userHoverProfile').visible
		},
		get content() {
			return Alpine.store('userHoverProfile').content
		}

	}));

	Alpine.data('userHoverProfileTrigger', ({id}) => ({
		id,
		showTimeout: null,
		show() {

			this.showTimeout = setTimeout(() => {
				Alpine.store('userHoverProfile').show(this.$root, this.id);
			}, 1000);


		},
		hide() {

			clearTimeout(this.showTimeout);

			Alpine.store('userHoverProfile').scheduleHide()
		},

		/*
		 * Clicking one of these usually means following a link. Put the card away now
		 * rather than waiting for a mouseleave that will never come, and drop the pending
		 * show so a card cannot appear a second after the page has already changed.
		 */
		dismiss() {

			clearTimeout(this.showTimeout);

			Alpine.store('userHoverProfile').hide();
		},

		cancelHide() {
			Alpine.store('userHoverProfile').cancelHide()
		},
	}));

});

